import { TextField } from "@mui/material";
import type { GridRenderEditCellParams } from "@mui/x-data-grid-premium";
import React from "react";

export const DataGridTextEditCell = ({
  id,
  field,
  value,
  api,
}: GridRenderEditCellParams) => {
  const [inputValue, setInputValue] = React.useState<string>(value ?? "");

  const commit = React.useCallback(
    (str: string) => {
      api.setEditCellValue({ id, field, value: str });
      api.stopCellEditMode({ id, field });
    },
    [id, field, api]
  );

  return (
    <TextField
      value={inputValue}
      onChange={e => setInputValue(e.target.value)}
      onBlur={e => commit(e.target.value)}
      onKeyDown={e => {
        if (e.key === "Enter") commit((e.target as HTMLInputElement).value);
        else if (e.key === "Escape")
          api.stopCellEditMode({ id, field, ignoreModifications: true });
      }}
      autoFocus
      size="extra-small"
      variant="outlined"
      sx={{ "& fieldset": { border: "none" } }}
      fullWidth
    />
  );
};
